import 'react-smartbanner/dist/main.css'
